import type { GlobalPopupsSettingsStoryblok } from '@/types/component-types-sb';
import { createStore } from 'zustand';
import { persist } from 'zustand/middleware';

export interface PopupState {
  settings?: GlobalPopupsSettingsStoryblok['global_popup'];
  displayedPopups: string[];
  markAsDisplayed: (uid: string) => void;
}

export type PopupStore = PopupState;
export type PopupStoreApi = ReturnType<typeof createPopupStore>;

export const createPopupStore = (initialState?: Partial<PopupState>) => {
  return createStore<PopupStore>()(
    persist(
      (set) => ({
        displayedPopups: [],
        ...initialState,
        markAsDisplayed: (uid) =>
          set((state) => ({
            displayedPopups: Array.from(new Set([...state.displayedPopups, uid])),
          })),
      }),
      {
        name: 'popup-store',
        version: 1,
        migrate: (persistedState, version) => {
          const previousState = persistedState as {
            closedPopups?: string[];
            displayedPopups?: string[];
          };

          if (version === 0) {
            return {
              displayedPopups: previousState.displayedPopups ?? previousState.closedPopups ?? [],
            } as PopupStore;
          }

          return persistedState as PopupStore;
        },
        partialize: (state) => ({ displayedPopups: state.displayedPopups }),
      }
    )
  );
};
